import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={26}
      height={26}
      rx={6.11765}
      fill="url(#paint0_linear_15401_16366)"
    />
    <path
      d="M6.3418 8.92748C6.3418 8.04122 7.06026 7.32275 7.94652 7.32275H19.3078C20.1941 7.32275 20.9126 8.04121 20.9126 8.92748V16.3448C20.9126 17.2311 20.1941 17.9495 19.3078 17.9495H7.94652C7.06026 17.9495 6.3418 17.2311 6.3418 16.3448V8.92748Z"
      fill="#D9D9D9"
    />
    <path
      d="M6.3418 8.92748C6.3418 8.04122 7.06026 7.32275 7.94652 7.32275H19.3078C20.1941 7.32275 20.9126 8.04121 20.9126 8.92748V16.3448C20.9126 17.2311 20.1941 17.9495 19.3078 17.9495H7.94652C7.06026 17.9495 6.3418 17.2311 6.3418 16.3448V8.92748Z"
      fill="url(#paint1_linear_15401_16366)"
    />
    <g filter="url(#filter0_b_15401_16366)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6718 19.2177C16.7917 19.4225 16.9403 19.653 17.1737 19.6959L18.8309 20C19.8272 20.1828 20.783 19.5234 20.9658 18.5272L21.3787 16.2777C21.3847 16.2448 21.362 16.2136 21.329 16.2075C20.6276 16.0788 20.1634 15.4058 20.2921 14.7044C20.4208 14.003 21.0938 13.5388 21.7952 13.6675C21.8281 13.6735 21.8605 13.6524 21.8665 13.6195L22.346 11.0072C22.5288 10.011 21.8694 9.05513 20.8732 8.87229L18.8644 8.50362C18.8319 8.49764 18.8014 8.52097 18.7954 8.55353C18.728 8.92093 18.3755 9.16411 18.0081 9.09668C17.6407 9.02925 17.3975 8.67675 17.4649 8.30934C17.4709 8.27679 17.4507 8.24416 17.4181 8.23818L7.66835 6.44881C6.67211 6.26598 5.71628 6.92536 5.53345 7.9216L5.12188 10.1641C5.07768 10.4049 5.23796 10.6313 5.44434 10.7631C5.87374 11.0373 6.11726 11.553 6.01962 12.085C5.92197 12.617 5.51122 13.0126 5.01243 13.1164C4.7727 13.1663 4.54249 13.3211 4.49829 13.5619L4.1533 15.4416C3.97046 16.4379 4.62985 17.3937 5.62609 17.5765L15.0243 19.3014C15.2577 19.3442 15.4785 19.1815 15.6633 19.0326C15.8113 18.9133 16.0084 18.8568 16.21 18.8938C16.4116 18.9308 16.5758 19.0536 16.6718 19.2177Z"
        fill="url(#paint2_linear_15401_16366)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6718 19.2177C16.7917 19.4225 16.9403 19.653 17.1737 19.6959L18.8309 20C19.8272 20.1828 20.783 19.5234 20.9658 18.5272L21.3787 16.2777C21.3847 16.2448 21.362 16.2136 21.329 16.2075C20.6276 16.0788 20.1634 15.4058 20.2921 14.7044C20.4208 14.003 21.0938 13.5388 21.7952 13.6675C21.8281 13.6735 21.8605 13.6524 21.8665 13.6195L22.346 11.0072C22.5288 10.011 21.8694 9.05513 20.8732 8.87229L18.8644 8.50362C18.8319 8.49764 18.8014 8.52097 18.7954 8.55353C18.728 8.92093 18.3755 9.16411 18.0081 9.09668C17.6407 9.02925 17.3975 8.67675 17.4649 8.30934C17.4709 8.27679 17.4507 8.24416 17.4181 8.23818L7.66835 6.44881C6.67211 6.26598 5.71628 6.92536 5.53345 7.9216L5.12188 10.1641C5.07768 10.4049 5.23796 10.6313 5.44434 10.7631C5.87374 11.0373 6.11726 11.553 6.01962 12.085C5.92197 12.617 5.51122 13.0126 5.01243 13.1164C4.7727 13.1663 4.54249 13.3211 4.49829 13.5619L4.1533 15.4416C3.97046 16.4379 4.62985 17.3937 5.62609 17.5765L15.0243 19.3014C15.2577 19.3442 15.4785 19.1815 15.6633 19.0326C15.8113 18.9133 16.0084 18.8568 16.21 18.8938C16.4116 18.9308 16.5758 19.0536 16.6718 19.2177Z"
        fill="url(#paint3_linear_15401_16366)"
      />
    </g>
    <g filter="url(#filter1_b_15401_16366)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1944 19.5831L18.8516 19.8873C19.7856 20.0587 20.6817 19.4405 20.8531 18.5065L21.2563 16.3097C20.5218 16.1465 20.0424 15.4299 20.1794 14.6837C20.3163 13.9376 21.019 13.4379 21.7635 13.5461L22.2332 10.9865C22.4046 10.0525 21.7865 9.15644 20.8525 8.98503L18.8968 8.62611C18.7956 9.0265 18.3995 9.28506 17.9874 9.20942C17.5753 9.13378 17.2968 8.75143 17.3443 8.34118L7.64766 6.56155C6.71369 6.39014 5.8176 7.00832 5.64619 7.94229L5.23463 10.1848C5.20243 10.3602 5.31892 10.547 5.50603 10.6665C5.97335 10.9649 6.2387 11.5262 6.13236 12.1057C6.02601 12.6851 5.57864 13.1156 5.0358 13.2286C4.81846 13.2739 4.64323 13.4071 4.61103 13.5826L4.26604 15.4623C4.09463 16.3963 4.71281 17.2924 5.64678 17.4638L15.045 19.1886C15.1285 19.2039 15.2159 19.1839 15.3106 19.1364C15.4061 19.0885 15.4991 19.0176 15.5913 18.9433C15.7642 18.804 15.9949 18.7378 16.2307 18.781C16.4665 18.8243 16.6586 18.9682 16.7708 19.1598C16.8306 19.262 16.8924 19.3613 16.9646 19.44C17.0363 19.518 17.1109 19.5678 17.1944 19.5831ZM17.1737 19.6959C16.9403 19.653 16.7917 19.4225 16.6718 19.2177C16.5758 19.0536 16.4116 18.9308 16.21 18.8938C16.0084 18.8568 15.8113 18.9133 15.6633 19.0326C15.4785 19.1815 15.2577 19.3442 15.0243 19.3014L5.62609 17.5765C4.62985 17.3937 3.97046 16.4379 4.1533 15.4416L4.49829 13.5619C4.54249 13.3211 4.7727 13.1663 5.01243 13.1164C5.51122 13.0126 5.92197 12.617 6.01962 12.085C6.11726 11.553 5.87374 11.0373 5.44434 10.7631C5.23796 10.6313 5.07768 10.4049 5.12188 10.1641L5.53345 7.9216C5.71628 6.92536 6.67211 6.26598 7.66835 6.44881L17.4181 8.23818C17.4507 8.24416 17.4709 8.27679 17.4649 8.30934C17.3975 8.67675 17.6407 9.02925 18.0081 9.09668C18.3755 9.16411 18.728 8.92093 18.7954 8.55353C18.8014 8.52097 18.8319 8.49764 18.8644 8.50362L20.8732 8.87229C21.8694 9.05513 22.5288 10.011 22.346 11.0072L21.8665 13.6195C21.8605 13.6524 21.8281 13.6735 21.7952 13.6675C21.0938 13.5388 20.4208 14.003 20.2921 14.7044C20.1634 15.4058 20.6276 16.0788 21.329 16.2075C21.362 16.2136 21.3847 16.2448 21.3787 16.2777L20.9658 18.5272C20.783 19.5234 19.8272 20.1828 18.8309 20L17.1737 19.6959Z"
        fill="url(#paint4_linear_15401_16366)"
        fillOpacity={0.53}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1944 19.5831L18.8516 19.8873C19.7856 20.0587 20.6817 19.4405 20.8531 18.5065L21.2563 16.3097C20.5218 16.1465 20.0424 15.4299 20.1794 14.6837C20.3163 13.9376 21.019 13.4379 21.7635 13.5461L22.2332 10.9865C22.4046 10.0525 21.7865 9.15644 20.8525 8.98503L18.8968 8.62611C18.7956 9.0265 18.3995 9.28506 17.9874 9.20942C17.5753 9.13378 17.2968 8.75143 17.3443 8.34118L7.64766 6.56155C6.71369 6.39014 5.8176 7.00832 5.64619 7.94229L5.23463 10.1848C5.20243 10.3602 5.31892 10.547 5.50603 10.6665C5.97335 10.9649 6.2387 11.5262 6.13236 12.1057C6.02601 12.6851 5.57864 13.1156 5.0358 13.2286C4.81846 13.2739 4.64323 13.4071 4.61103 13.5826L4.26604 15.4623C4.09463 16.3963 4.71281 17.2924 5.64678 17.4638L15.045 19.1886C15.1285 19.2039 15.2159 19.1839 15.3106 19.1364C15.4061 19.0885 15.4991 19.0176 15.5913 18.9433C15.7642 18.804 15.9949 18.7378 16.2307 18.781C16.4665 18.8243 16.6586 18.9682 16.7708 19.1598C16.8306 19.262 16.8924 19.3613 16.9646 19.44C17.0363 19.518 17.1109 19.5678 17.1944 19.5831ZM17.1737 19.6959C16.9403 19.653 16.7917 19.4225 16.6718 19.2177C16.5758 19.0536 16.4116 18.9308 16.21 18.8938C16.0084 18.8568 15.8113 18.9133 15.6633 19.0326C15.4785 19.1815 15.2577 19.3442 15.0243 19.3014L5.62609 17.5765C4.62985 17.3937 3.97046 16.4379 4.1533 15.4416L4.49829 13.5619C4.54249 13.3211 4.7727 13.1663 5.01243 13.1164C5.51122 13.0126 5.92197 12.617 6.01962 12.085C6.11726 11.553 5.87374 11.0373 5.44434 10.7631C5.23796 10.6313 5.07768 10.4049 5.12188 10.1641L5.53345 7.9216C5.71628 6.92536 6.67211 6.26598 7.66835 6.44881L17.4181 8.23818C17.4507 8.24416 17.4709 8.27679 17.4649 8.30934C17.3975 8.67675 17.6407 9.02925 18.0081 9.09668C18.3755 9.16411 18.728 8.92093 18.7954 8.55353C18.8014 8.52097 18.8319 8.49764 18.8644 8.50362L20.8732 8.87229C21.8694 9.05513 22.5288 10.011 22.346 11.0072L21.8665 13.6195C21.8605 13.6524 21.8281 13.6735 21.7952 13.6675C21.0938 13.5388 20.4208 14.003 20.2921 14.7044C20.1634 15.4058 20.6276 16.0788 21.329 16.2075C21.362 16.2136 21.3847 16.2448 21.3787 16.2777L20.9658 18.5272C20.783 19.5234 19.8272 20.1828 18.8309 20L17.1737 19.6959Z"
        fill="url(#paint5_linear_15401_16366)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1944 19.5831L18.8516 19.8873C19.7856 20.0587 20.6817 19.4405 20.8531 18.5065L21.2563 16.3097C20.5218 16.1465 20.0424 15.4299 20.1794 14.6837C20.3163 13.9376 21.019 13.4379 21.7635 13.5461L22.2332 10.9865C22.4046 10.0525 21.7865 9.15644 20.8525 8.98503L18.8968 8.62611C18.7956 9.0265 18.3995 9.28506 17.9874 9.20942C17.5753 9.13378 17.2968 8.75143 17.3443 8.34118L7.64766 6.56155C6.71369 6.39014 5.8176 7.00832 5.64619 7.94229L5.23463 10.1848C5.20243 10.3602 5.31892 10.547 5.50603 10.6665C5.97335 10.9649 6.2387 11.5262 6.13236 12.1057C6.02601 12.6851 5.57864 13.1156 5.0358 13.2286C4.81846 13.2739 4.64323 13.4071 4.61103 13.5826L4.26604 15.4623C4.09463 16.3963 4.71281 17.2924 5.64678 17.4638L15.045 19.1886C15.1285 19.2039 15.2159 19.1839 15.3106 19.1364C15.4061 19.0885 15.4991 19.0176 15.5913 18.9433C15.7642 18.804 15.9949 18.7378 16.2307 18.781C16.4665 18.8243 16.6586 18.9682 16.7708 19.1598C16.8306 19.262 16.8924 19.3613 16.9646 19.44C17.0363 19.518 17.1109 19.5678 17.1944 19.5831ZM17.1737 19.6959C16.9403 19.653 16.7917 19.4225 16.6718 19.2177C16.5758 19.0536 16.4116 18.9308 16.21 18.8938C16.0084 18.8568 15.8113 18.9133 15.6633 19.0326C15.4785 19.1815 15.2577 19.3442 15.0243 19.3014L5.62609 17.5765C4.62985 17.3937 3.97046 16.4379 4.1533 15.4416L4.49829 13.5619C4.54249 13.3211 4.7727 13.1663 5.01243 13.1164C5.51122 13.0126 5.92197 12.617 6.01962 12.085C6.11726 11.553 5.87374 11.0373 5.44434 10.7631C5.23796 10.6313 5.07768 10.4049 5.12188 10.1641L5.53345 7.9216C5.71628 6.92536 6.67211 6.26598 7.66835 6.44881L17.4181 8.23818C17.4507 8.24416 17.4709 8.27679 17.4649 8.30934C17.3975 8.67675 17.6407 9.02925 18.0081 9.09668C18.3755 9.16411 18.728 8.92093 18.7954 8.55353C18.8014 8.52097 18.8319 8.49764 18.8644 8.50362L20.8732 8.87229C21.8694 9.05513 22.5288 10.011 22.346 11.0072L21.8665 13.6195C21.8605 13.6524 21.8281 13.6735 21.7952 13.6675C21.0938 13.5388 20.4208 14.003 20.2921 14.7044C20.1634 15.4058 20.6276 16.0788 21.329 16.2075C21.362 16.2136 21.3847 16.2448 21.3787 16.2777L20.9658 18.5272C20.783 19.5234 19.8272 20.1828 18.8309 20L17.1737 19.6959Z"
        fill="url(#paint6_linear_15401_16366)"
      />
    </g>
    <path
      d="M13.9932 14.1632L14.0181 14.1681L14.023 14.1432L14.1938 13.2703L14.1987 13.2454L14.1738 13.2405L12.9191 12.995L15.6049 9.93407L15.634 9.90093L15.5907 9.89246L13.8752 9.55674L13.8598 9.55374L13.8502 9.56609L11.869 12.1217L11.8209 12.1123L10.9942 9.00747L10.9901 8.99215L10.9745 8.98911L9.21385 8.64455L9.17119 8.6362L9.18493 8.67745L10.463 12.5144L9.19646 12.2665L9.17157 12.2616L9.1667 12.2865L8.99588 13.1594L8.99101 13.1843L9.0159 13.1892L10.7066 13.52L10.5634 14.2513L8.87279 13.9204L8.84791 13.9156L8.84304 13.9405L8.67221 14.8134L8.66734 14.8383L8.69223 14.8431L10.3829 15.174L10.0056 17.1017L10.0008 17.1265L10.0257 17.1314L11.5719 17.434L11.5968 17.4389L11.6017 17.414L11.9789 15.4863L13.6696 15.8172L13.6944 15.822L13.6993 15.7971L13.8701 14.9242L13.875 14.8993L13.8501 14.8945L12.1595 14.5636L12.3026 13.8324L13.9932 14.1632Z"
      fill="url(#paint7_linear_15401_16366)"
      stroke="white"
      strokeWidth={0.0507135}
    />
    <g filter="url(#filter2_d_15401_16366)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8884 16.9828C16.8724 17.0721 16.787 17.1315 16.6976 17.1155C16.6083 17.0995 16.5489 17.0141 16.5649 16.9247L16.7971 15.6307C16.8131 15.5414 16.8985 15.482 16.9879 15.498C17.0772 15.5141 17.1366 15.5995 17.1206 15.6888L16.8884 16.9828ZM17.2947 14.7177C17.2786 14.8071 17.1932 14.8665 17.1039 14.8505C17.0145 14.8344 16.9551 14.749 16.9712 14.6597L17.2034 13.3657C17.2194 13.2764 17.3048 13.2169 17.3941 13.233C17.4835 13.249 17.5429 13.3344 17.5269 13.4237L17.2947 14.7177ZM17.5062 12.5852C17.5956 12.6013 17.681 12.5418 17.697 12.4525L17.9292 11.1585C17.9452 11.0692 17.8858 10.9838 17.7965 10.9677C17.7071 10.9517 17.6217 11.0111 17.6057 11.1005L17.3735 12.3945C17.3575 12.4838 17.4169 12.5692 17.5062 12.5852Z"
        fill="#5162C6"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_15401_16366"
        x={1.83058}
        y={4.12599}
        width={22.8388}
        height={18.1968}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.14623} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_15401_16366"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_15401_16366"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_15401_16366"
        x={1.83058}
        y={4.12599}
        width={22.8388}
        height={18.1968}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.14623} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_15401_16366"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_15401_16366"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_15401_16366"
        x={15.6455}
        y={10.0483}
        width={3.20311}
        height={7.98681}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.458494} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.423529 0 0 0 0 0.8 0 0 0 0 1 0 0 0 0.36 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_15401_16366"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_15401_16366"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15401_16366"
        x1={31.5}
        y1={33.5}
        x2={-0.500001}
        y2={-2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1C77FF" />
        <stop offset={1} stopColor="#44C7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_15401_16366"
        x1={13.6272}
        y1={7.32275}
        x2={13.6272}
        y2={17.9495}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6AC9FF" />
        <stop offset={1} stopColor="#73E2F1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_15401_16366"
        x1={11.765}
        y1={2.94066}
        x2={10.0669}
        y2={19.3738}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.394418} stopColor="#FFFEFD" stopOpacity={0} />
        <stop offset={0.920537} stopColor="#FFFEFD" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_15401_16366"
        x1={17.7904}
        y1={18.114}
        x2={13.6821}
        y2={6.55596}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFEFD" stopOpacity={0} />
        <stop offset={1} stopColor="#FFFEFD" stopOpacity={0.78} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_15401_16366"
        x1={19.4477}
        y1={20.3311}
        x2={17.6368}
        y2={10.1867}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_15401_16366"
        x1={7.92109}
        y1={8.39252}
        x2={8.43611}
        y2={14.9418}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_15401_16366"
        x1={13.7}
        y1={6.28239}
        x2={11.4146}
        y2={12.4863}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={0.730783} stopColor="white" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="paint7_linear_15401_16366"
        x1={15.0467}
        y1={19.7843}
        x2={6.02669}
        y2={4.61429}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4386FE" />
        <stop offset={1} stopColor="#84E1FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
